import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BackgroundImage from "%/dynamic-component-editor/options/background-image";
import BackgroundSize from "%/dynamic-component-editor/options/background-size";
import BackgroundRepeat from "%/dynamic-component-editor/options/background-repeat";
import BackgroundPosition from "%/dynamic-component-editor/options/background-position";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import BackgroundGradient from "%/dynamic-component-editor/options/background-gradient";

export default class BackgroundOptions extends BaseOptionsBundle {

  optionTitle = "Background";
  inspectorToolGroup = "background";
  useInspectorLabel = false;

  static optionClassName = "i-dynamic-background";
  static userInterfaceComponent = {
    component: inspectorTools.BACKGROUND_TOOL_SET,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new BackgroundColor(undefined, hideFromInspector["background-color"] ?? false),
      new BackgroundGradient(undefined, hideFromInspector["background-gradient"] ?? false),
      new BackgroundImage(undefined, hideFromInspector["background-image"] ?? false),
      BackgroundSize,
      BackgroundRepeat,
      BackgroundPosition,
    ]);
  }
}
